import "./TableDateNav.scss";
import previousIcon from "assets/icons/previous.svg";
import nextIcon from "assets/icons/next.svg";
import { Typography } from "core/typography/Typography";
import moment from "moment";
import PropTypes from "prop-types";

const TableDateNav = ({ selectedDate, setSelectedDate, setSelectedYear }) => {
  return (
    <div className="year-selector-wrapper">
      <button
        className="previous-year-wrapper"
        onClick={(event) => {
          event.preventDefault();
          const newDate = moment(selectedDate)
            .subtract(1, "year")
            .format("YYYY-MM-DD");
          setSelectedDate(newDate);
          setSelectedYear(Number(moment(newDate).format("YYYY")));
        }}
      >
        <input
          type="image"
          className="previous-year-icon"
          src={previousIcon}
          alt="previous-year-icon"
        />
        <Typography
          className="title-4 violet"
          type="h2"
          label={Number(
            moment(selectedDate).subtract(1, "year").format("YYYY")
          )}
        />
      </button>
      <button
        className="next-year-wrapper"
        onClick={(event) => {
          event.preventDefault();
          const newDate = moment(selectedDate)
            .add(1, "year")
            .format("YYYY-MM-DD");
          setSelectedDate(newDate);
          setSelectedYear(Number(moment(newDate).format("YYYY")));
        }}
      >
        <Typography
          className="title-4 violet"
          type="h2"
          label={Number(moment(selectedDate).add(1, "year").format("YYYY"))}
        />
        <input
          type="image"
          className="next-year-icon"
          src={nextIcon}
          alt="next-year-icon"
        />
      </button>
    </div>
  );
};

TableDateNav.propTypes = {
  selectedDate: PropTypes.string,
  setSelectedDate: PropTypes.func,
  setSelectedYear: PropTypes.func,
};

export default TableDateNav;
